import React from 'react';
// components
import Loading from '../Loading';
// pages
import Error from '../../../pages/Error';

/**
 * Standardizes the loading + critical-error UI across every page.
 *
 * Pass a single value or an array of values; arrays are reduced with `.some()`,
 * so you can feed it several query states at once.
 *
 * IMPORTANT: only pass CRITICAL queries here (e.g. the page's own GET_PAGE_DATA).
 * Optional sections (sponsors, events, ranking, ...) should NOT be passed in —
 * they should degrade in place with `?.` guards so a single stale/failed query
 * can never take down the whole page again.
 */
export default function PageState({ loading, error, children }) {
  const isLoading = (Array.isArray(loading) ? loading : [loading]).some(Boolean);
  if (isLoading) return <Loading />;

  const hasError = (Array.isArray(error) ? error : [error]).some(Boolean);
  if (hasError) {
    return <Error code="502" text="Invalid response. Please try again later." />;
  }

  return <>{children}</>;
}
